import * as Api from './api';
import * as App from './app';

const wix = {
  Api: Api,
  App: App,
};

export { wix };
